import { useEffect } from "react";
import { ListItem } from "../components/common/useFilters";

const useFilterRequest = (
  state,
  setNumOfActiveFilters,
  action,
  additionalParams = undefined
) => {
  useEffect(() => {
    let params = {},
      numOfActiveFilters = 0;
    Object.keys(state).forEach((key: string) => {
      if (state[key].isFilterActive) numOfActiveFilters++;
      if (key === "debouncedValue") {
        const searchValue = state[key];
        if (searchValue.trim()) {
          params["free_text"] = searchValue;
          numOfActiveFilters++;
        }
      }
      if (key === "sortBy") {
        const sortBy = state[key];
        if (sortBy) {
          params["order_by"] = sortBy;
          params["reverse"] = state.isSortReverse;
        }
      }

      if (state[key].isFilterActive) {
        params[key] = [];
        state[key].options.forEach((listItem: ListItem) => {
          if (listItem.selected) {
            if (key === "hours") {
              params[listItem.value] = true;
            } else if (key === "accessibility_searchmap") {
              if (!params["accessibility"]) {
                params["accessibility"] = [];
              }
              params["accessibility"].push(listItem.value);
            } else {
              params[key].push(listItem.value);
            }
            if (
              key === "is_digital" &&
              params["is_digital"].includes(true) &&
              params["is_digital"].includes(false)
            ) {
              delete params["is_digital"];
            }
          }
        });
      }

      if (state[key].type === "checkbox") {
        numOfActiveFilters += state[key].selectedOptions.length;
        state[key].selectedOptions.forEach(
          (item: string) => (params[item] = true)
        );
      }
    });

    if (Object.keys(state).length) {
      if (additionalParams) {
        params = { ...params, ...additionalParams };
      }
      action(params);
    }
    setNumOfActiveFilters(numOfActiveFilters);
  }, [state, action, additionalParams, setNumOfActiveFilters]);
};

export default useFilterRequest;
